<template>
    <div class="container-fluid dashboard-sales-view">
        <div class="row mb-3">
            <div class="col-12">
                <div class="hero-card">
                    <div>
                        <span class="hero-kicker">bSales dashboard</span>
                        <h2 class="page-title"><i class="fas fa-tachometer-alt"></i> Retail summary</h2>
                        <p class="hero-copy">Track your leads’ performance, their sources, and how they convert into sales.</p>
                    </div>
                    <div class="hero-tag">Live retail</div>
                </div>
            </div>
        </div>

        <div v-if="isLoading" class="card">
            <div class="card-body text-center py-5">
                <Loader></Loader>
            </div>
        </div>

        <div v-else>
            <div class="row">
                <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
                    <SummaryLeadsStatusCard :stats="leadsStats" :period-label="leadsPeriodLabel"></SummaryLeadsStatusCard>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
                    <SummaryOutcomesCard :counts="counts"></SummaryOutcomesCard>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
                    <SummarySourcesCard :sources="sourceSummary"></SummarySourcesCard>
                </div>
                <div class="col-xl-12 col-lg-6 col-md-12 mb-4">
                    <SummaryLeadsSourcesCard :rows="leadsSourceRows" :period-label="leadsPeriodLabel"></SummaryLeadsSourcesCard>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 mb-4">
                    <SummaryPipelineCard :counts="counts"></SummaryPipelineCard>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 mb-4">
                    <SummaryStagesCard :counts="counts"></SummaryStagesCard>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Loader from "@/core/components/shared/Loader.vue";
import SummaryPipelineCard from "@/apps/bsales/components/Dashboard/SummaryPipelineCard.vue";
import SummaryStagesCard from "@/apps/bsales/components/Dashboard/SummaryStagesCard.vue";
import SummaryOutcomesCard from "@/apps/bsales/components/Dashboard/SummaryOutcomesCard.vue";
import SummarySourcesCard from "@/apps/bsales/components/Dashboard/SummarySourcesCard.vue";
import SummaryLeadsStatusCard from "@/apps/bsales/components/Dashboard/SummaryLeadsStatusCard.vue";
import SummaryLeadsSourcesCard from "@/apps/bsales/components/Dashboard/SummaryLeadsSourcesCard.vue";

const SALES_STATUS_ALL = [0, 1, 2, 3, 4, 5, 6, 7];
const LEADS_START_YEAR = 2020;

export default {
    name: "Dash_bSales",
    components: {
        Loader,
        SummaryPipelineCard,
        SummaryStagesCard,
        SummaryOutcomesCard,
        SummarySourcesCard,
        SummaryLeadsStatusCard,
        SummaryLeadsSourcesCard,
    },
    data() {
        return {
            isLoading: true,
            sales_type: "retail",
            query: "",
            counts: {
                leads: 0,
                qualification: 0,
                appointment: 0,
                estimate: 0,
                closing: 0,
                sold: 0,
                rejected: 0,
                all: 0,
            },
            salesList: [],
            leadsStats: {
                total: 0,
                active: 0,
                inSales: 0,
                spam: 0,
                trash: 0,
                uncategorized: 0,
            },
            leadsSourceRows: [],
            leadsPeriodLabel: LEADS_START_YEAR + " - " + new Date().getFullYear(),
            isOwner: false,
        };
    },
    created() {
        // @ts-ignore
        this.isOwner = window.user_type == 0;
        this.loadDashboard();
    },
    methods: {
        loadDashboard() {
            this.isLoading = true;

            Promise.all([
                this.getSalesCount(),
                this.getSalesList(),
                this.getLeadsSummary(),
            ]).finally(() => {
                this.isLoading = false;
            });
        },
        getBaseFilter() {
            let dataFilter = {
                org_id: window.localorgdata,
                user_id: window.master_client,
                sales_type: this.sales_type,
            };

            let appID = this.$store.getters["core/apps/getAppIDactual"];
            let appRolUser = this.$store.getters["core/apps/get_appRolUser"];
            let validAdminApp = appRolUser.filter(r => {
                if (appID == r.app_id && r.rol == 1) {
                    return r;
                }
            });

            if (!this.isOwner && validAdminApp.length == 0) {
                dataFilter.seller_ids = window.localAccountID;
            }

            return dataFilter;
        },
        getSalesCount() {
            return window.master.post("getSalesCounts", this.getBaseFilter())
                .then((response) => {
                    let count = response.data.count;

                    if (!count.length) {
                        return;
                    }

                    this.counts.leads = count[0].leads || 0;
                    this.counts.qualification = count[0].qualification || 0;
                    this.counts.appointment = count[0].appointment || 0;
                    this.counts.estimate = count[0].estimate || 0;
                    this.counts.closing = count[0].closing || 0;
                    this.counts.sold = count[0].sold || 0;
                    this.counts.rejected = count[0].rejected || 0;
                    this.counts.all = this.counts.leads + this.counts.qualification + this.counts.appointment + this.counts.estimate + this.counts.closing + this.counts.sold + this.counts.rejected;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getSalesList() {
            let dataFilter = this.getBaseFilter();
            dataFilter.status = SALES_STATUS_ALL;

            return window.master.post("getSales", dataFilter)
                .then((response) => {
                    if (!response.data.status) {
                        this.salesList = [];
                        return;
                    }

                    this.salesList = response.data.getList.data || [];
                })
                .catch((error) => {
                    console.log(error);
                    this.salesList = [];
                });
        },
        getLeadsSummary() {
            const urlApis = this.$store.getters["ModApps/Marketea/urlApis"];
            const leadsApi = urlApis && urlApis.leads ? urlApis.leads : null;
            const endpoint = leadsApi && typeof leadsApi.gets === "function"
                ? leadsApi.gets(this.query)
                : "leads/form" + this.query;

            const socketId = typeof pusher !== "undefined" && pusher.connection
                ? pusher.connection.socket_id
                : null;

            const endYear = new Date().getFullYear();
            const years = [];
            for (let year = LEADS_START_YEAR; year <= endYear; year++) {
                years.push(year);
            }

            const requests = years.map((year) => {
                return window.master.post(endpoint, {
                    org_id: window.localorgdata,
                    user_id: window.master_client,
                    search: "",
                    year: year,
                    source_id: 0,
                    cta_id: 0,
                    quality_id: 0,
                    socket_id: socketId,
                });
            });

            return Promise.all(requests)
                .then((responses) => {
                    const leadsMap = {};
                    const salesMap = {};
                    const sourceMapCatalog = {};

                    responses.forEach((response) => {
                        const data = response.data || {};
                        const leads = data.leadsAllYear || [];
                        const sales = data.sales_leads || [];
                        const sources = data.listCRM && data.listCRM.crm_mark_source
                            ? data.listCRM.crm_mark_source
                            : [];

                        leads.forEach((lead) => {
                            leadsMap[String(lead.id)] = lead;
                        });

                        sales.forEach((sale) => {
                            const key = String(sale.id || sale.lead_id + "_" + sale.sales_status);
                            salesMap[key] = sale;
                        });

                        sources.forEach((source) => {
                            sourceMapCatalog[source.id] = source;
                        });
                    });

                    const leadsAllYear = Object.keys(leadsMap).map((key) => leadsMap[key]);
                    const salesLeads = Object.keys(salesMap).map((key) => salesMap[key]);
                    const sourceCatalog = Object.keys(sourceMapCatalog).map((key) => sourceMapCatalog[key]);

                    const soldLeadIds = new Set(
                        salesLeads
                            .filter(s => s.sales_status == 6)
                            .map(s => String(s.lead_id))
                    );

                    const statusSummary = {
                        total: leadsAllYear.length,
                        active: 0,
                        inSales: 0,
                        spam: 0,
                        trash: 0,
                        uncategorized: 0,
                    };

                    let sourceMap = {};
                    sourceCatalog.forEach(s => {
                        sourceMap[s.id] = {
                            name: s.name,
                            leads: 0,
                            sold: 0,
                        };
                    });

                    let uncategorized = {
                        name: "Uncategorized",
                        leads: 0,
                        sold: 0,
                    };

                    leadsAllYear.forEach(lead => {
                        if (lead.status == 4) {
                            statusSummary.spam += 1;
                        } else if (lead.status == 5) {
                            statusSummary.trash += 1;
                        } else {
                            statusSummary.active += 1;
                        }

                        if (lead.status == 6) {
                            statusSummary.inSales += 1;
                        }

                        const sourceId = lead.source_id;
                        const isUncategorized = sourceId == null || sourceId == "null" || sourceId == 0;
                        const isSold = soldLeadIds.has(String(lead.id));

                        if (isUncategorized) {
                            statusSummary.uncategorized += 1;
                            uncategorized.leads += 1;
                            if (isSold) {
                                uncategorized.sold += 1;
                            }
                            return;
                        }

                        if (!sourceMap[sourceId]) {
                            sourceMap[sourceId] = {
                                name: "Source " + sourceId,
                                leads: 0,
                                sold: 0,
                            };
                        }

                        sourceMap[sourceId].leads += 1;
                        if (isSold) {
                            sourceMap[sourceId].sold += 1;
                        }
                    });

                    this.leadsStats = statusSummary;

                    const sourceRows = Object.keys(sourceMap)
                        .map(key => sourceMap[key])
                        .filter(s => s.leads > 0)
                        .sort((a, b) => b.leads - a.leads)
                        .slice(0, 5)
                        .map(s => [s.name, s.leads, s.sold]);

                    if (uncategorized.leads > 0) {
                        sourceRows.push([uncategorized.name, uncategorized.leads, uncategorized.sold]);
                    }

                    this.leadsSourceRows = sourceRows;
                })
                .catch((error) => {
                    console.log(error);
                    this.leadsStats = {
                        total: 0,
                        active: 0,
                        inSales: 0,
                        spam: 0,
                        trash: 0,
                        uncategorized: 0,
                    };
                    this.leadsSourceRows = [];
                });
        },
    },
    computed: {
        sourceSummary() {
            let summary = this.salesList.reduce((acc, item) => {
                let sourceName = "Uncategorized";

                if (item.sourceName) {
                    sourceName = item.sourceName;
                } else if (item.source && item.source.name) {
                    sourceName = item.source.name;
                }

                if (!acc[sourceName]) {
                    acc[sourceName] = 0;
                }

                acc[sourceName += ""] += 1;
                return acc;
            }, {});

            return Object.keys(summary)
                .map(key => [key, summary[key]])
                .sort((a, b) => b[1] - a[1])
                .slice(0, 6);
        },
    },
};
</script>
<style lang="scss" scoped>
.dashboard-sales-view {
    padding-bottom: 16px;
}

.hero-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 22px 26px;
    border-radius: 20px;
    background: linear-gradient(135deg, #16324f 0%, #214f7a 50%, #2b7ca8 100%);
    color: #fff;
    box-shadow: 0 20px 35px rgba(27, 62, 96, 0.2);
}

.hero-kicker {
    display: inline-block;
    margin-bottom: 8px;
    padding: 6px 10px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.14);
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.page-title {
    color: #fff;
    margin-bottom: 6px;
}

.hero-copy {
    margin: 0;
    color: rgba(255, 255, 255, 0.82);
}

.hero-tag {
    min-width: 110px;
    text-align: center;
    padding: 12px 14px;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
}

@media (max-width: 767px) {
    .hero-card {
        flex-direction: column;
        align-items: flex-start;
    }

    .hero-tag {
        min-width: auto;
    }
}
</style>
